/* FVS Step 8 and Step 17 */
import { ReactElement } from 'react';
import { tile, iFVSInfoDisplay } from '@interfaces/interfaces';
import { Field, useFormikContext } from 'formik';
import { iFVSFormValues } from '@services/FVSService';
import { GenderOptionsList, OriginOptionsList, EnglishProficiencyOptionsList } from '@constants';
import { TextInput, DropdownMenu, TileRadio } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import classnames from 'classnames';
import styles from './BackgroundAndIdentityDetails.module.scss';

interface iBackgroundAndIdentityDetails {
  displayObject: iFVSInfoDisplay;
  currentStepNo: string;
}

function BackgroundAndIdentityDetails({ displayObject, currentStepNo }: iBackgroundAndIdentityDetails): ReactElement {
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const { Gender, HasDisability, EnglishProficiency } = values;
  const { pageTitle, pageSubtitle, pageInfo } = displayObject.pages.backgroundAndIdentityDetails[currentStepNo];
  const { gender, genderDescription, lgtiqIdentified, origin, englishProficiency, nativeLanguage, isDisabled, disabilityDescription } = displayObject.pages.backgroundAndIdentityDetails[currentStepNo].fields;

  return (
    <div className={gridStyles.form}>
      <div className="vfH2">{pageTitle}</div>
      <p className="subHeadingH3">
        <span
          className={classnames({
            [styles.bold]: true,
            [styles.subHeadingH3]: true,
          })}>
          Answering these questions is optional. &nbsp;
        </span>
        {pageSubtitle}
      </p>
      <p
        className={classnames({
          [styles.subInfo]: true,
          subHeadingH3: true,
        })}>
        {pageInfo}
      </p>
      <div className={gridStyles.gridColFull}>
        <Field name={gender.formikName} component={DropdownMenu} title={gender.title} displayText={GenderOptionsList} defaultOption />
      </div>
      {Gender === 'self-described' && (
        <div className={gridStyles.gridColFull}>
          <Field name={genderDescription.formikName} component={TextInput} title={genderDescription.title} />
        </div>
      )}
      <div className={gridStyles.gridColFull}>
        <Field name={lgtiqIdentified.formikName} title={lgtiqIdentified.title} component={TileRadio} tileData={TILE_DATA} orientationRow />
      </div>
      <div className={gridStyles.gridColFull}>
        <Field name={origin.formikName} title={origin.title} component={DropdownMenu} displayText={OriginOptionsList} defaultOption />
      </div>
      <div className={gridStyles.gridColFull}>
        <Field name={englishProficiency.formikName} title={englishProficiency.title} component={DropdownMenu} displayText={EnglishProficiencyOptionsList} defaultOption />
      </div>
      {(EnglishProficiency === 'not-at-all' || EnglishProficiency === 'poorly') && (
        <div className={gridStyles.gridColFull}>
          <Field name={nativeLanguage.formikName} component={TextInput} title={nativeLanguage.title} />
        </div>
      )}
      <div className={gridStyles.gridColFull}>
        <Field name={isDisabled.formikName} title={isDisabled.title} component={TileRadio} tileData={TILE_DATA} orientationRow />
      </div>
      {HasDisability === 'true' && (
        <div className={gridStyles.gridColFull}>
          <Field name={disabilityDescription.formikName} component={TextInput} title={disabilityDescription.title} />
        </div>
      )}
    </div>
  );
}

export default BackgroundAndIdentityDetails;
